import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { SearchSelectionSchema } from '@exam-management/qcontent-management';
import { z } from 'zod';

const NAME_MIN_LENGTH = 1;
const NAME_MAX_LENGTH = 1024;

const locationSchema = z.object({
  [QBankStructureLevelCategory.Part]: SearchSelectionSchema.nullish(),
  [QBankStructureLevelCategory.Subject]: SearchSelectionSchema.nullish(),
  [QBankStructureLevelCategory.Group]: SearchSelectionSchema.nullish(),
  [QBankStructureLevelCategory.Chapter]: SearchSelectionSchema.nullish(),
  [QBankStructureLevelCategory.Topic]: SearchSelectionSchema.nullish(),
  [QBankStructureLevelCategory.SubTopic]: SearchSelectionSchema.nullish(),
});

export const QuestionReviewTaskCreationFormSchema = z.object({
  taskName: z
    .string({
      message: 'กรุณากรอก Task Name',
    })
    .trim()
    .min(1, {
      message: 'กรุณากรอก Task Name',
    })
    .max(NAME_MAX_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .min(NAME_MIN_LENGTH, {
      message: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    }),
  courseId: z.object(
    {
      label: z.string(),
      value: z.string(),
    },
    {
      message: 'กรุณาเลือกคลังข้อสอบ (Course)',
    },
  ),
  question: z
    .object(
      {
        questionId: z.record(z.string().uuid(), z.boolean().nullish()),
      },
      { message: 'กรุณาเลือกข้อสอบ (Question)' },
    )
    .optional(),
  location: locationSchema,
});

export type QuestionReviewTaskCreationFormInput = z.infer<
  typeof QuestionReviewTaskCreationFormSchema
>;

export type LocationSchemaFormInput = z.infer<typeof locationSchema>;
